export default __webpack_public_path__ + "81610ff23f15162afdee449ee4cdad73.png";